import { takeEvery, put, call } from 'redux-saga/effects';
import { loginStart, loginSuccess, loginFail, registerStart, registerSuccess, registerFail, logoutStart, logoutSuccess, logoutFail, refreshStart, refreshSuccess, refreshFail } from '../slices/authSlice';
import { postRequest } from '../../network';
import { login, register, logout, refresh } from '../apis';
function* loginSaga(action) {
    try {
        const response = yield call(postRequest, login, action.payload.params);
        yield put(loginSuccess(response));
        if (action.payload.callback) {
            action.payload.callback(null, response);
        }
    } catch (error) {
        const errorMessage =
            error.response?.data?.errors?.[0] || 
            error.response?.data?.message ||   
            error.message ||
            "An unknown error occurred";
        yield put(loginFail(errorMessage));
        if (action.payload.callback) {
            action.payload.callback(errorMessage, null);
        }
    }
}

function* registerSaga(action) {
    try {
        const response = yield call(postRequest, register, action.payload);
        yield put(registerSuccess(response));
        action.callback(null, response);
    } catch (error) {
        yield put(registerFail(error.message));
        action.callback(error.message, null);
    }
}

// Logout Saga
function* logoutSaga(action) {
    try {
        yield call(postRequest, logout, null); // Assuming logout doesn't require payload
        yield put(logoutSuccess());
        action.callback(null, true);
    } catch (error) {
        yield put(logoutFail(error.message));
        action.callback(error.message, null);
    }
}

// Refresh Token Saga
function* refreshSaga(action) {
    try {
        const response = yield call(postRequest, refresh, action.payload);
        yield put(refreshSuccess(response));
        action.callback(null, response);
    } catch (error) {
        yield put(refreshFail(error.message));
        action.callback(error.message, null);
    }
}

// Watcher Saga
export function* watchAuth() {
    yield takeEvery(loginStart.type, loginSaga);
    yield takeEvery(registerStart.type, registerSaga);
    yield takeEvery(logoutStart.type, logoutSaga);
    yield takeEvery(refreshStart.type, refreshSaga);
}